import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalActions } from '@/stores/action/widget.action';
import { userActions, sendActions } from '@/stores/action/home.action';
import BankAccount from './BankAccount';
import Form from './Form';
import { toNumber } from '@/utils/calculate.util';
import { getLocaleWordContent } from '@/utils/language.util';

function Withdraw({ mymode, user, ModalActions, UserActions, SendActions }) {
    const [qty, setQty] = useState('');
    const [pin, setPin] = useState('');
    const [fee_calc, setFee] = useState('');
    const [calc, setCalc] = useState('');
    const history = useHistory();

    const fee = Number(user.getIn(['withdraw_fee'])) || '';

    const handleOpenModal = (e) => {
        ModalActions.showModalEx({ mode: 2 });
    };
    const fetchBusinesses = () => {
        UserActions.getUserBalance();
    };
    useEffect(fetchBusinesses, []);

    const handleChange = (e, name) => {
        if (e) e.preventDefault();

        if (name === 'qty') {
            setQty(toNumber(e.target.value));
        } else if (name === 'pin') {
            setPin(toNumber(e.target.value));
        }
    };
    const NextPage = (e, page) => {
        if (e) e.preventDefault();
        history.replace('/' + page);
    };

    return (
        <>
            <div className="bg_balance_left">
                {mymode.mode === 2 ? <BankAccount ModalActions={ModalActions} /> : <div />}
                <div className="inner">
                    <button className="b_orange btn02" onClick={handleOpenModal}>
                        {getLocaleWordContent('은행계좌등록')}
                    </button>
                </div>
                <div className="sp25"></div>
                <div className="log_box">
                    <Form
                        user={user}
                        pin={pin}
                        qty={qty}
                        fee={fee}
                        fee_calc={fee_calc}
                        calc={calc}
                        setFee={setFee}
                        setCalc={setCalc}
                        setQty={setQty}
                        setPin={setPin}
                        handleChange={handleChange}
                        SendActions={SendActions}
                    />
                    <div className="sp30"></div>
                    <p>{getLocaleWordContent('회원 출금 요청 시 관리자가 수동으로 출금 진행합니다.')}</p>
                    <p>{getLocaleWordContent('출금 요청 전 회원 은행 계좌 등록 진행 하시기바랍니다.')} </p>
                    <p>{getLocaleWordContent('출금신청시간')}:</p>
                    <ul>
                        <li>{getLocaleWordContent('오후2시까지 신청 시 당일 출금')}</li>
                        <li>{getLocaleWordContent('오후2시이후 출금 신청시 익일 출금')}</li>
                    </ul>
                    <div className="sp15"></div>
                    <div className="bottom-btn text-center">
                        <button className="b_orange btn02" onClick={(e) => NextPage(e, 'sphistory/?tab2')}>
                            {getLocaleWordContent('출금 내역')}
                        </button>
                    </div>
                    <div className="sp30"></div>
                </div>
            </div>
        </>
    );
}
export default connect(
    (state) => ({
        mymode: state.widget.getIn(['modalEx', 'mode']),
        user: state.home.getIn(['user']),
    }),
    (dispatch) => ({
        ModalActions: bindActionCreators(modalActions, dispatch),
        UserActions: bindActionCreators(userActions, dispatch),
        SendActions: bindActionCreators(sendActions, dispatch),
    }),
)(Withdraw);
